import React from 'react';
import { Field } from 'formik';
import cn from 'classnames';

import './input.field.scss';

const InputField = ({
	type, error, touched, maxLength, ...props
}) => (
	<div className="input-wrapper">
		<Field type={type || 'input'} className={cn('form-input', { 'with-error': error && touched })} {...props} />
		{error && touched && <div className="error">{error}</div>}
	</div>
);

export default InputField;
